import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b18db22c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b18db22c')) {
      api.createRecord('b18db22c', component.options)
    } else {
      api.reload('b18db22c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b18db22c&", function () {
      api.rerender('b18db22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/venueBooking/venueBasicManage/venueAreaCharge/index.vue"
export default component.exports